<template>
  <p role="status" class="text-[1rem] text-gray-700" data-testid="loading-notice">
    <span class="material-icons-round animate-spin align-middle text-[1rem]" aria-hidden="true">autorenew</span>&nbsp;<slot />
  </p>
</template>
